msgid ""
msgstr ""
"POT-Creation-Date: 2025-03-06 15:53+0200\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: pseudo-LOCALE\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. placeholder {0}: item.maxSurge
#. placeholder {0}: item.maximum
#. placeholder {0}: item.minimum
#. placeholder {1}: item.maxSurge
#. placeholder {1}: item.maximum
#. placeholder {1}: item.minimum
#: src/modules/services/FailoverNodeSelect.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "{0} {1, plural, one {node} other {nodes}}"
msgstr ""

#. placeholder {0}: uploadStats.uploadedFiles
#. placeholder {1}: uploadStats.totalFiles
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "{0} of {1} files uploaded"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "{name} will be deleted permanently."
msgstr ""

#: src/modules/storage/StorageList.tsx
msgid "{number_of_buckets, plural, one {bucket} other {buckets}}"
msgstr ""

#. {resourceTypeName} is eg. 'virtual machine' or 'billing account'
#: src/modules/api/resourceTypeException.tsx
msgid "{resourceTypeName} with ID {id} not found"
msgstr ""

#. ONLY:bn
#: src/styles/tenbyte/theme.tsx
msgid "<0><1>Individual/Proprietor: NID, Passport, or Driver's License.</1><2>Company/Corporate: Trade License.</2><3>Financial & Legal: Tax Identification Number (TIN), VAT Certificate.</3></0>"
msgstr ""

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "1 bare metal server"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "1 day"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "1 hour"
msgstr ""

#: src/modules/billing/omise/OmisePaymentForm.tsx
msgid "10 digit TrueMoney mobile number starting with 0"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "3 days"
msgstr ""

#: src/modules/compute/VmView.tsx
msgid "4 weeks"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "6 hours"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "7 days"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "A discount has been applied for all services under this billing account."
msgstr ""

#: src/modules/compute/VmCreate.tsx
msgid "A user account will be created with this username. It can be used to log in to the VM. Can contain ASCII letters, digits, underscores and hyphens. Must start with a letter or underscore. Maximum length is 25 characters."
msgstr ""

#: src/modules/network/NetworkCreate.tsx
msgid "A virtual private cloud (VPC) is a private network interface for collections of your resources. VPC network is available at no additional cost."
msgstr ""

#: src/modules/access/AcceptInvitationModal.tsx
#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accept"
msgstr ""

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accept invitation"
msgstr ""

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/user/ProfileView.tsx
msgid "Accepted"
msgstr ""

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accepting this access invitation will grant you permission to act as \"{name}\" and perform all operations on behalf of the user."
msgstr ""

#. Label for dropdown menu that has options related to file sharing and permissions. | POS: Noun
#. Title for section that contains credentials to connect to a database
#: src/modules/access/AccessList.tsx
#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/services/Access.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Access"
msgstr ""

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Access credentials"
msgstr ""

#: src/modules/api/resourceTypes.tsx
msgid "Access delegation"
msgstr ""

#: src/modules/user/ProfileView.tsx
msgid "Access group"
msgstr ""

#: src/modules/user/InvitationNotice.tsx
msgid "Access has been shared with you"
msgstr ""

#: src/modules/api/resourceTypes.tsx
msgid "Access invitation"
msgstr ""

#. placeholder {0}: item.access_owner
#: src/modules/user/InvitationNotice.tsx
msgid "Access invitation from {0} is pending"
msgstr ""

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Access key ID"
msgstr ""

#: src/modules/access/AccessCreate.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
msgid "Access name"
msgstr ""

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Access scope"
msgstr ""

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
msgid "Access type"
msgstr ""

#. Dialog title
#: src/modules/user/ActAsModal.tsx
msgid "Access user"
msgstr ""

#: src/modules/billing/account_validation/BillingAccountValidationBlock.tsx
#: src/modules/billing/NoValidBillingAccountNotice.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Account details are being validated."
msgstr ""

#: src/modules/billing/account_validation/GeneralBaValidationBlock.tsx
msgid "Account details must be validated"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Account ID"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Account name"
msgstr ""

#. Menu item to impersonate another user
#: src/modules/user/ActAsModal.tsx
#: src/modules/user/UserMenu.tsx
msgid "Act as"
msgstr ""

#. placeholder {0}: impersonation.access_owner
#: src/modules/user/ImpersonateTopItem.tsx
msgid "Acting as <0>{0}</0>"
msgstr ""

#. Login page title when email verification is required
#: src/modules/login/auth0/Auth0Login.tsx
msgid "Action required"
msgstr ""

#. Billing account status
#. Disk status
#. Service status
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
#: src/modules/compute/statusLabels.tsx
#: src/modules/disks/DiskStatusBadge.tsx
msgid "Active"
msgstr ""

#: src/modules/storage/StorageCreate.tsx
msgid "Actual cost of your storage is calculated hourly based on your actual usage, no upfront payments. For every started GB the price is rounded up to next whole GB."
msgstr ""

#: src/modules/services/ServiceView.tsx
msgid "Actual price is determined by compute and storage usage. Persistent volumes of hibernated clusters will still be charged for. See billing account current usage for more detailed information."
msgstr ""

#. Add a new row; Button action
#: src/components/EditableList.tsx
#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/compute/AddFirewallForm.tsx
#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/metal/commitment/AddCommitmentModal.tsx
#: src/modules/network/firewall/AddResourceForm.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/loadbalancer/AddForwardingRuleForm.tsx
#: src/modules/network/loadbalancer/AddTargetServerForm.tsx
#: src/modules/services/AddIpForm.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Add"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Add a a payment method that supports automated top up."
msgstr ""

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmView.tsx
msgid "Add additional disk"
msgstr ""

#: src/modules/network/NetworkCreate.tsx
msgid "Add at least one forwarding rule"
msgstr ""

#: src/modules/network/NetworkCreate.tsx
msgid "Add at least one target server"
msgstr ""

#: src/modules/compute/VmCreate.tsx
msgid "Add custom configuration for the virtual machine"
msgstr ""

#: src/modules/user/ProfileView.tsx
msgid "Add first name"
msgstr ""

#: src/modules/services/IpWhitelist.tsx
msgid "Add IP"
msgstr ""

#: src/modules/user/ProfileView.tsx
msgid "Add last name"
msgstr ""

#: src/components/table/DetailsTableName.tsx
msgid "Add name"
msgstr ""

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Add new payment method..."
msgstr ""

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "Add new reservation"
msgstr ""

#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Add new rule"
msgstr ""

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Add node"
msgstr ""

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Add node pool"
msgstr ""

#: src/modules/billing/ActionButtons.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Add payment method"
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Add payment method later"
msgstr ""

#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "Add rule"
msgstr ""

#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/VmCreate.tsx
msgid "Add SSH key"
msgstr ""

#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "Add sub-interface"
msgstr ""

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Add target server"
msgstr ""

#: src/modules/access/delegation/AddImpersonationForm.tsx
msgid "Add user"
msgstr ""

#: src/modules/access/delegation/DelegationView.tsx
msgid "Add users"
msgstr ""

#: src/modules/billing/choose_method/useAddMethod.tsx
msgid "Adding payment method failed"
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/network/NetworkList.tsx
msgid "Address"
msgstr ""

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Address line 2"
msgstr ""

#. Link to administrative user interface
#: src/modules/user/UserMenu.tsx
msgid "Admin view"
msgstr ""

#. Who changed the billing account status
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Administrator"
msgstr ""

#. What caused the billing account status change
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Administrator action"
msgstr ""

#: src/components/table/DetailsTableBillingAccount.tsx
#: src/components/WTabs.tsx
msgid "All"
msgstr ""

#. A firewall rule that applies to every source or destination IP address
#: src/modules/network/firewall/firewallLabels.tsx
msgid "All IP addresses"
msgstr ""

#: src/modules/storage/account/StorageAccountView.tsx
msgid "All permissions"
msgstr ""

#: src/modules/network/firewall/ruleSpec.tsx
msgid "All TCP"
msgstr ""

#: src/modules/network/firewall/ruleSpec.tsx
msgid "All UDP"
msgstr ""

#: src/modules/api/resourceTypes.tsx
msgid "Allocate a floating IP and start managing your network."
msgstr ""

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Allocated"
msgstr ""

#: src/modules/network/NetworkCreate.tsx
msgid "Allocating a new IPv4 address allows you to assign it to one of your existing resources or reserve it for later use."
msgstr ""

#: src/modules/login/Login.tsx
msgid "Already have an account?"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Amount"
msgstr ""

#. Field label for reservation upfront cost
#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "Amount billed upfront"
msgstr ""

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Amount is too low"
msgstr ""

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Amount should be positive"
msgstr ""

#: src/modules/billing/AutomatedTopUpModal.tsx
msgid "Amount should not be less than than minimum top up"
msgstr ""

#: src/modules/billing/NoValidBillingAccountNotice.tsx
msgid "An active billing account is needed to create resources."
msgstr ""

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "An active billing account is needed to use this feature."
msgstr ""

#: src/modules/billing/account_validation/BillingAccountValidationBlock.tsx
msgid "An e-mail with instructions has been sent to you."
msgstr ""

#: src/components/modal/WModal.tsx
#: src/components/sidebar/ListErrorBoundary.tsx
msgid "An error happened"
msgstr ""

#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/firewall/ruleSpec.tsx
#: src/modules/network/firewall/ruleSpec.tsx
msgid "Any"
msgstr ""

#: src/modules/access/AccessList.tsx
#: src/modules/dashboard/WelcomeBlock.tsx
#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "API"
msgstr ""

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "API documentation"
msgstr ""

#: src/modules/api/resourceTypes.tsx
msgid "API token"
msgstr ""

#: src/modules/compute/labels.tsx
#: src/modules/dashboard/StartSomethingNew.tsx
msgid "App catalog"
msgstr ""

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Appearance"
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Apply for payment by invoice"
msgstr ""

#: src/modules/compute/SubInterfaceDeleteModal.tsx
msgid "Are you sure you want to delete sub-interface with uuid {ifUuid}?"
msgstr ""

#: src/modules/compute/SshKeyDeleteModal.tsx
msgid "Are you sure you want to delete the public key \"{name}\"?"
msgstr ""

#: src/modules/main/LogoutConfirmDialog.tsx
msgid "Are you sure you want to log out?"
msgstr ""

#: src/modules/network/NetworkCreate.tsx
msgid "Assign to"
msgstr ""

#. State of IP address, attached to a resource such as a virtual machine
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkList.tsx
msgid "Assigned"
msgstr ""

#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Assigned to"
msgstr ""

#: src/modules/access/AccessCreate.tsx
msgid "At least one email is required"
msgstr ""

#: src/modules/network/firewall/EditRuleModal.tsx
msgid "At least one IP is required"
msgstr ""

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "At least one node pool must have autoscaler minimum value as 1 or more."
msgstr ""

#: src/modules/compute/VmView.tsx
msgid "Attach firewall"
msgstr ""

#: src/modules/network/firewall/FirewallView.tsx
msgid "Attach resource"
msgstr ""

#: src/modules/disks/DiskList.tsx
msgid "Attached"
msgstr ""

#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskCreate.tsx
msgid "Attached to"
msgstr ""

#. Explanation: Switching the color schema automatically. |Alternatives: 'Automatic'
#: src/modules/main/ColorSchemeMenu.tsx
msgid "Auto"
msgstr ""

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Auto update"
msgstr ""

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Automated payment"
msgstr ""

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Automated top up"
msgstr ""

#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Automatic system-level backups are enabled. Use the backup images to restore your service. Backups will be stored for 7 days, meaning you will have 7 latest backups."
msgstr ""

#: src/modules/compute/VmView.tsx
msgid "Automatic system-level backups are enabled. Use the backup images to restore your virtual machine or create a new virtual machine from the backup with modified size parameters."
msgstr ""

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Automatic updates will not update preview versions."
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Automatically top up (min. <0/>)"
msgstr ""

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Autoscaler max."
msgstr ""

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Autoscaler min."
msgstr ""

#: src/modules/metal/status/StatusLabels.tsx
msgid "Available"
msgstr ""

#: src/modules/services/ServiceView.tsx
msgid "Awake"
msgstr ""

#. Button action
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
msgid "Back"
msgstr ""

#: src/modules/user/ImpersonateTopItem.tsx
#: src/modules/user/UserMenu.tsx
msgid "Back to your account"
msgstr ""

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
msgid "Backups"
msgstr ""

#. Table column: billing account balance when the change happened
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Balance"
msgstr ""

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Balance became negative"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Balance became positive"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Balance history"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Balance negative for {days, plural, one {# day} other {# days}} (limit: {threshold, plural, one {# day} other {# days}})"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Balance negative for too long"
msgstr ""

#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/metal/MetalList.tsx
msgid "Bare metal"
msgstr ""

#: src/modules/api/resourceTypes.tsx
msgid "Bare metal server"
msgstr ""

#: src/modules/billing/BaseCurrencyField.tsx
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Base currency"
msgstr ""

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Begin your billing account validation process."
msgstr ""

#: src/modules/compute/SubInterfaceModal.tsx
msgid "Below is an example of how to configure this sub-interface on a Linux server."
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Below the top-up threshold"
msgstr ""

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Billed"
msgstr ""

#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Billing"
msgstr ""

#: src/components/table/DetailsTableBillingAccount.tsx
#: src/components/table/DetailsTableBillingAccount.tsx
#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/forms/BillingAccountField.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Billing account"
msgstr ""

#. Price list annotation
#: src/modules/pricing/PricingModal.tsx
msgid "Billing account \"{title}\" has discount {discount_percentage}%"
msgstr ""

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Billing account created"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Billing account deleted"
msgstr ""

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Billing account is limited"
msgstr ""

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Billing account name"
msgstr ""

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Billing account override"
msgstr ""

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Billing account reactivated"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/statusHistory/StatusHistory.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Billing account suspended"
msgstr ""

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Billing account updated"
msgstr ""

#. What caused the billing account status change
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Billing account validation"
msgstr ""

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Billing account validation was rejected"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Billing account waiting for validation"
msgstr ""

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Billing accounts"
msgstr ""

#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "Billing cycle"
msgstr ""

#: src/modules/disks/disk/DiskView.tsx
msgid "Boot"
msgstr ""

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Boot from ISO medium"
msgstr ""

#. Virtual machine choice: UEFI or BIOS
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
msgid "Boot mode"
msgstr ""

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Booting is only possible when the virtual machine is stopped."
msgstr ""

#. {payment method} provided by {payment gateway name}
#: src/modules/billing/utils.tsx
msgid "by {gatewayName}"
msgstr ""

#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "By continuing with the top up you agree to the <0>Terms & Conditions</0>, <1>Privacy Policy</1> & <2>Refund Policy</2>."
msgstr ""

#: src/modules/compute/VmView.tsx
msgid "By disabling backups there will not be any further automatic backups made from your virtual machine. Backups done by this point will be kept as is and you can still use them. You can enable backups again whenever needed."
msgstr ""

#: src/modules/access/AccessCreate.tsx
msgid "By selecting “Global”, all resources under this user account can be accessed. Exercise caution when selecting “Global” scope."
msgstr ""

#: src/modules/access/AccessCreate.tsx
msgid "By selecting “Restricted”, access will be limited to resources belonging to the selected billing account."
msgstr ""

#: src/modules/login/auth0/Auth0Login.tsx
msgid "By signing up, you agree to the <0>Terms of Service</0>"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Campaign code"
msgstr ""

#: src/modules/dashboard/UserAccess.tsx
msgid "Can access me"
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Cancel"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Cancel uploads"
msgstr ""

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Cancelled"
msgstr ""

#: src/modules/billing/payment_forms/labels.tsx
msgid "Card number"
msgstr ""

#: src/modules/billing/omise/parseOmisePersistentData.ts
msgid "Card verification failed"
msgstr ""

#: src/modules/compute/ChangePasswordModal.tsx
msgid "Change"
msgstr ""

#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/ChangePasswordModal.tsx
msgid "Change password"
msgstr ""

#: src/modules/login/Login.tsx
msgid "Change your password by clicking the verification link we just sent to your inbox."
msgstr ""

#. Table column: who changed the billing account status
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Changed by"
msgstr ""

#: src/modules/user/ProfileView.tsx
msgid "Changing the password failed"
msgstr ""

#: src/modules/compute/ChangePasswordModal.tsx
msgid "Changing the password is only possible when the virtual machine is running."
msgstr ""

#: src/modules/billing/forms/BillingAccountField.tsx
msgid "Choose a billing account for your new resource to consolidate your resources under a suitable payment method."
msgstr ""

#: src/modules/access/AccessCreate.tsx
msgid "Choose a billing account you wish to share access to"
msgstr ""

#: src/modules/network/NetworkCreate.tsx
msgid "Choose a resource to assign the IP to or leave it unassigned. You can always assign the IP to a suitable resource later"
msgstr ""

#: src/modules/disks/DiskCreate.tsx
msgid "Choose a virtual machine to attach the disk to, or leave it detached and connect it to a virtual machine later."
msgstr ""

#: src/modules/compute/VmCreate.tsx
#: src/modules/services/ServiceCreate.tsx
msgid "Choose a VPC network for your resource from already existing one or create a new private network."
msgstr ""

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Choose billing account"
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/choose_method/ChooseMethod.tsx
msgid "Choose method"
msgstr ""

#: src/modules/network/NetworkCreate.tsx
msgid "Choose the VPC network the target servers are in."
msgstr ""

#: src/modules/compute/VmCreate.tsx
msgid "Choose UEFI if the VM you are importing requires it."
msgstr ""

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "City"
msgstr ""

#: src/modules/metal/status/StatusLabels.tsx
msgid "Cleaning"
msgstr ""

#. Billing account restriction level | POS: Adjective
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Clear"
msgstr ""

#: src/modules/notifications/NotificationMenu.tsx
msgid "Clear all"
msgstr ""

#. Button: Remove the over-ride of the billing account for this bucket
#: src/modules/storage/bucket/BucketView.tsx
msgid "Clear override"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Clear uploads"
msgstr ""

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Click the button to connect to PayPal."
msgstr ""

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/compute/VmCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
msgid "Clone"
msgstr ""

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
msgid "Clone resource"
msgstr ""

#. Button action
#: src/components/modal/WModal.tsx
#: src/components/sidebar/ErrorItem.tsx
#: src/modules/access/delegation/AddImpersonationForm.tsx
#: src/modules/compute/AddFirewallForm.tsx
#: src/modules/network/firewall/AddResourceForm.tsx
#: src/modules/network/loadbalancer/AddForwardingRuleForm.tsx
#: src/modules/network/loadbalancer/AddTargetServerForm.tsx
#: src/modules/services/AddIpForm.tsx
msgid "Close"
msgstr ""

#. Label for an authentication error code
#: src/modules/login/auth0/Auth0Login.tsx
msgid "Code:"
msgstr ""

#. Server has been pre-paid
#: src/modules/metal/commitment/CommitmentPriceBlock.tsx
msgid "Committed"
msgstr ""

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Company name"
msgstr ""

#: src/styles/dataxion/theme.tsx
msgid "Company RNE number"
msgstr ""

#: src/modules/access/token/TokenView.tsx
msgid "Comprehensive API manual with code samples is available here:"
msgstr ""

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Compute"
msgstr ""

#. Alternative: Configure a custom subnet range
#: src/modules/network/NetworkCreate.tsx
msgid "Configure my own"
msgstr ""

#: src/modules/login/Login.tsx
msgid "Confirm email"
msgstr ""

#: src/modules/compute/PasswordFields.tsx
msgid "Confirm password"
msgstr ""

#: src/modules/login/Login.tsx
msgid "Confirm your email address by clicking the verification link we just sent to your inbox."
msgstr ""

#: src/components/modal/DeleteModal.tsx
#: src/modules/main/LogoutConfirmDialog.tsx
msgid "Confirmation"
msgstr ""

#: src/modules/compute/WVnc.tsx
msgid "Connect"
msgstr ""

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Connect to PayPal first"
msgstr ""

#: src/modules/compute/WVnc.tsx
msgid "Connecting"
msgstr ""

#: src/modules/billing/progressLabels.tsx
msgid "Connecting payment method"
msgstr ""

#. Title for section that contains credentials to connect to a database
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/services/ServiceView.tsx
msgid "Connection details"
msgstr ""

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Contact person's name"
msgstr ""

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Contact person's phone"
msgstr ""

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/support/ContactSupportButton.tsx
msgid "Contact support"
msgstr ""

#: src/modules/billing/account_validation/digio/StartDigioValidationButton.tsx
#: src/modules/login/ConsentForm.tsx
#: src/modules/login/Login.tsx
msgid "Continue"
msgstr ""

#: src/components/ClipBoardTooltip.tsx
msgid "Copied!"
msgstr ""

#. Full form: Copy to clipboard
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Copy"
msgstr ""

#: src/modules/services/Access.tsx
msgid "Copy config to clipboard"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Copy public URL"
msgstr ""

#: src/components/ClipBoardTooltip.tsx
msgid "Copy to clipboard"
msgstr ""

#. All the main resources and services offered by the cloud platform
#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Core services"
msgstr ""

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Country"
msgstr ""

#. Part of address
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "County"
msgstr ""

#: src/modules/compute/MetricsGrid.tsx
#: src/modules/compute/VmSizeSelect.tsx
#: src/modules/compute/VmSizeSelect.tsx
msgid "CPU"
msgstr ""

#. Button: Create a new resource
#: src/components/forms/CreateFormAction.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Create"
msgstr ""

#. Button: Create new billing account
#: src/modules/dashboard/BillingAccounts.tsx
msgctxt "Should be short (1-3 words)"
msgid "Create"
msgstr ""

#: src/modules/billing/BillingList.tsx
msgid "Create a billing account first, then you can start creating resources."
msgstr ""

#: src/modules/api/resourceTypes.tsx
msgid "Create a dedicated bare metal server and run your application with maximum performance."
msgstr ""

#: src/modules/error/ErrorFallback.tsx
msgid "Create a new {resourceTypeName}"
msgstr ""

#: src/modules/access/AccessList.tsx
msgid "Create a new access to enable other users or systems to perform actions with this {siteName} account."
msgstr ""

#: src/modules/disks/DiskList.tsx
msgid "Create a new disk and start storing your data."
msgstr ""

#: src/modules/compute/VmList.tsx
#: src/modules/metal/MetalList.tsx
msgid "Create a new resource and get your services running in minutes."
msgstr ""

#: src/modules/network/NetworkList.tsx
msgid "Create a new resource and start managing your network."
msgstr ""

#: src/modules/services/ServicesList.tsx
msgid "Create a new service and get it running in minutes."
msgstr ""

#: src/modules/api/resourceTypes.tsx
msgid "Create a new storage account, create some buckets and start storing your data in a scalable way - Pay-as-you-grow."
msgstr ""

#: src/modules/storage/StorageList.tsx
msgid "Create a new storage account, create some buckets and start storing your data."
msgstr ""

#: src/modules/api/resourceTypes.tsx
msgid "Create a new Virtual Machine or choose something from the App Catalog to get your services running in minutes."
msgstr ""

#: src/modules/api/resourceTypes.tsx
msgid "Create a personal Virtual Private Cloud (VPC) and start managing your networks."
msgstr ""

#: src/modules/network/CreateAndAssignIpField.tsx
msgid "Create a public IPv4 address for the resource"
msgstr ""

#: src/modules/disks/DiskCreate.tsx
msgid "Create additional storage for your workloads. Configure the disk and attach it to a virtual machine now or later."
msgstr ""

#: src/modules/login/Login.tsx
msgid "Create an account"
msgstr ""

#: src/modules/api/resourceTypes.tsx
msgid "Create an API Token to use our API."
msgstr ""

#. placeholder {0}: getResourceTypeName(type)
#: src/components/loading/Loading.tsx
msgid "Create another {0}"
msgstr ""

#: src/components/forms/CreateBillingAccount.tsx
msgid "Create billing account"
msgstr ""

#: src/components/forms/CreateBillingAccount.tsx
#: src/modules/access/AccessCreate.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/dashboard/AppCatalog.tsx
#: src/modules/dashboard/CoreServices.tsx
#: src/modules/dashboard/ManagedServices.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/account/CreateBucketModal.tsx
#: src/modules/storage/account/CreateBucketModal.tsx
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/StorageCreate.tsx
#: src/modules/storage/StorageList.tsx
msgid "Create new"
msgstr ""

#. Created at timestamp
#: src/modules/access/AccessList.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/user/ProfileView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Created"
msgstr ""

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Created at"
msgstr ""

#: src/modules/access/AccessList.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/services/ServicesList.tsx
msgid "Created date"
msgstr ""

#: src/modules/compute/ModalHeaderBlock.tsx
msgid "Created from"
msgstr ""

#. Virtual machine status
#: src/components/loading/Loading.tsx
#: src/modules/compute/statusLabels.tsx
msgid "Creating"
msgstr ""

#: src/modules/access/AccessCreate.tsx
msgid "Creating an access by API Token gives you a key to use with our API."
msgstr ""

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Credit"
msgstr ""

#. What caused the billing account status change
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Credit adjustment"
msgstr ""

#: src/modules/billing/evc_hormuud/EvcHormuudPaymentForm.tsx
msgid "Credit is added to this billing account automatically once the payment is received. Make sure the billing account ID is entered correctly."
msgstr ""

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Credit Note {id}"
msgstr ""

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Current"
msgstr ""

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "Current billing cycle"
msgstr ""

#. Explanation: Restoring a snapshot or backup will delete the current state of the virtual machine.
#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Current changes will be discarded."
msgstr ""

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Current usage"
msgstr ""

#: src/modules/compute/VmSizeSelect.tsx
msgid "Currently not available"
msgstr ""

#. Custom operating system
#: src/modules/compute/os/OsInfo.tsx
#: src/modules/network/firewall/ruleSpec.tsx
msgid "Custom"
msgstr ""

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Custom ISO image"
msgstr ""

#: src/modules/support/WChatProvider.tsx
msgid "Customer support"
msgstr ""

#: src/modules/billing/payment_forms/labels.tsx
msgid "CVC"
msgstr ""

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Dark"
msgstr ""

#: src/modules/dashboard/Dashboard.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Dashboard"
msgstr ""

#: src/modules/location/LocationDetail.tsx
msgid "Data center where resource is located"
msgstr ""

#: src/modules/location/LocationField.tsx
msgid "Data center where the resource will be created."
msgstr ""

#: src/components/forms/WSelect.tsx
msgid "Data missing"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Date"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Declined / Suspended"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/dashboard/BillingAccounts.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Default"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Default level for post-payment billing accounts"
msgstr ""

#: src/modules/access/AccessCreate.tsx
msgid "Delegate access to"
msgstr ""

#: src/modules/api/resourceTypes.tsx
msgid "Delegate access to your user or billing account so trusted users can manage your resources."
msgstr ""

#: src/modules/user/ProfileView.tsx
msgid "Delegate new access"
msgstr ""

#: src/modules/access/AccessCreate.tsx
msgid "Delegating access to a chosen trusted user enables the user to act as you and perform all operations on behalf of your user or billing account."
msgstr ""

#: src/components/button/DeleteButton.tsx
#: src/components/modal/DeleteModal.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Delete"
msgstr ""

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "Delete floating IP"
msgstr ""

#. Virtual machine status
#: src/modules/compute/statusLabels.tsx
#: src/modules/metal/status/StatusLabels.tsx
msgid "Deleted"
msgstr ""

#: src/modules/metal/MetalDeleteModal.tsx
msgid "Deleting \"{display_name}\" will permanently remove it, and it will not be accessible after that."
msgstr ""

#: src/modules/metal/MetalDeleteModal.tsx
msgid "Deleting \"{display_name}\" would destroy a resource that has already been paid for. Please contact support for assistance."
msgstr ""

#: src/modules/access/delegation/DelegationView.tsx
msgid "Deleting \"{name}\" will permanently remove access from all the users in this group to act as you."
msgstr ""

#. Items: means files or folders
#. placeholder {0}: files.length
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Deleting {count} {0, plural, one {item} other {items}}."
msgstr ""

#: src/modules/compute/VmDeleteReplicaModal.tsx
msgid "Deleting a backup will permanently remove it."
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting a billing account \"{title}\" will remove it permanently. Billing account can be deleted only if there are no unpaid resources attached to it and if it has no unspent credit."
msgstr ""

#. placeholder {0}: method.name
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting a payment method \"{0}\" will remove it from the billing account."
msgstr ""

#: src/modules/services/ServiceDeleteModal.tsx
msgid "Deleting a service will also delete your backups and the service cannot be restored after that."
msgstr ""

#: src/modules/compute/VmDeleteReplicaModal.tsx
msgid "Deleting a snapshot will permanently remove it."
msgstr ""

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Deleting the access key \"{accessKey}\" will permanently remove it, and it cannot be used for accessing the storage API after that."
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting the credit card \"{placeholder}\" will permanently remove it from the billing account."
msgstr ""

#: src/modules/compute/DiskDeleteModal.tsx
msgid "Deleting the disk will permanently remove it, and it will not be accessible after that."
msgstr ""

#. placeholder {0}: name || address
#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "Deleting the floating IP address \"{0}\" will remove it from your account and release it to the public pool."
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting the invoice method will permanently remove it from the billing account."
msgstr ""

#: src/modules/services/ServiceDeleteModal.tsx
msgid "Deleting the service \"{display_name}\" will permanently remove it, and it will not be accessible after that."
msgstr ""

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Deleting the storage account \"{title}\" will permanently remove it and delete all associated keys. Accounts with active buckets cannot be deleted."
msgstr ""

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Deleting the storage bucket \"{name}\" will permanently remove it, and any files in it will not be accessible after that."
msgstr ""

#: src/modules/access/token/TokenView.tsx
msgid "Deleting the token \"{description}\" will permanently remove it, and it cannot be used for authentication after that."
msgstr ""

#: src/modules/compute/VmDeleteModal.tsx
msgid "Deleting the virtual machine \"{name}\" will permanently remove it, and it will not be accessible after that."
msgstr ""

#: src/modules/compute/VmDeleteModal.tsx
msgid "Deleting the virtual machine will also delete your backups and snapshots, and the machine cannot be restored after that. If you wish to keep the backups and snapshots consider stopping the machine instead."
msgstr ""

#: src/modules/network/vpc/VpcView.tsx
msgid "Deleting the VPC network \"{name}\" will remove it from your account."
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Description"
msgstr ""

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Destinations"
msgstr ""

#: src/modules/disks/AttachedToSelect.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/disks/UnattachedItem.tsx
msgid "Detached"
msgstr ""

#: src/modules/compute/VmView.tsx
msgid "Disable"
msgstr ""

#: src/modules/compute/VmView.tsx
msgid "Disable backups"
msgstr ""

#: src/modules/user/ProfileView.tsx
msgid "Disable MFA"
msgstr ""

#: src/components/EnabledDisabled.tsx
msgid "Disabled"
msgstr ""

#: src/modules/compute/WVnc.tsx
msgid "Disconnect"
msgstr ""

#. State of connection: Not connected
#: src/modules/compute/WVnc.tsx
msgid "Disconnected"
msgstr ""

#. Column title for invoice records' discount
#: src/components/PriceWithDiscount.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Discount"
msgstr ""

#: src/modules/api/resourceTypes.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Disk"
msgstr ""

#: src/modules/compute/MetricsGrid.tsx
msgid "Disk I/O"
msgstr ""

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
msgid "Disk size can only be increased. This action is not reversible. Minimum disk size:"
msgstr ""

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Disks"
msgstr ""

#: src/modules/billing/CurrencyPaymentFees.tsx
#: src/modules/currency/CurrencyModal.tsx
#: src/modules/currency/CurrencyModal.tsx
msgid "Display currency"
msgstr ""

#: src/modules/storage/StorageCreate.tsx
msgid "Display name"
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Document"
msgstr ""

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Document file"
msgstr ""

#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Document No."
msgstr ""

#. Button action to download a file. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Download"
msgstr ""

#: src/modules/services/Access.tsx
msgid "Download config file"
msgstr ""

#: src/modules/billing/invoice/DownloadPdf.tsx
msgid "Download PDF"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Drop files here"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Due date"
msgstr ""

#: src/modules/login/auth0/Auth0Login.tsx
msgid "E-mail"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/UpdateSshKeyModal.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Edit"
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Edit \"{title}\""
msgstr ""

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Edit maintenance"
msgstr ""

#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Edit name"
msgstr ""

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Edit node"
msgstr ""

#: src/modules/network/firewall/EditRuleModal.tsx
msgid "Edit rule"
msgstr ""

#. Field label
#: src/components/EditableList.tsx
#: src/modules/login/Login.tsx
#: src/modules/user/ProfileView.tsx
msgid "Email"
msgstr ""

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Email domain is prohibited"
msgstr ""

#: src/modules/login/Login.tsx
msgid "Email verification failed"
msgstr ""

#: src/modules/login/Login.tsx
msgid "Email verified"
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Email where invoices and reports are sent."
msgstr ""

#: src/modules/compute/VmCreate.tsx
msgid "Empty disk (for ISO booting)"
msgstr ""

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Enable"
msgstr ""

#: src/modules/user/ProfileView.tsx
msgid "Enable MFA"
msgstr ""

#: src/modules/access/AccessCreate.tsx
msgid "Enable other users or systems to perform actions with resources connected to this account."
msgstr ""

#: src/components/EnabledDisabled.tsx
msgid "Enabled"
msgstr ""

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "End date"
msgstr ""

#: src/modules/network/firewall/firewallLabels.tsx
msgid "End port"
msgstr ""

#: src/modules/network/firewall/validatePorts.ts
msgid "End port must be greater than start port"
msgstr ""

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Ended"
msgstr ""

#: src/modules/compute/AddSubInterfaceModal.tsx
msgid "Enter a value between 1 and 4094"
msgstr ""

#. Card security code validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Enter digits only"
msgstr ""

#. placeholder {0}: currency.title
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Enter the top up amount in {0} (minimum {minimumAmount}):"
msgstr ""

#: src/modules/billing/payment/PaymentModal.tsx
#: src/modules/error/Isolated.tsx
#: src/modules/login/Login.tsx
#: src/modules/notifications/toast.tsx
msgid "Error"
msgstr ""

#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Error adding payment method"
msgstr ""

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Error code: {code}"
msgstr ""

#: src/components/button/WButton.tsx
msgid "Error performing action"
msgstr ""

#: src/modules/notifications/toast.tsx
msgid "Error saving changes"
msgstr ""

#: src/modules/compute/VmView.tsx
msgid "Est. cost per backup"
msgstr ""

#: src/components/table/DetailsTableMonthlyCost.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Est. monthly cost"
msgstr ""

#. Short of: Estimated
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Est. total"
msgstr ""

#: src/components/forms/MonthlyCostField.tsx
msgid "Estimated cost"
msgstr ""

#: src/modules/pricing/ReplicaPrice.tsx
msgid "Estimated price per backup is {priceWithDiscount} per month."
msgstr ""

#: src/modules/pricing/ReplicaPrice.tsx
msgid "Estimated price per snapshot is {priceWithDiscount} per month."
msgstr ""

#. Table column: what happened to the billing account
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Event"
msgstr ""

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Every new user receives a {c_totalReceiverCredit} worth of free credits when signing up through the referral link or code and adding a verified payment method."
msgstr ""

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Every new user who signs up through the referral program and tops up at least {c_minimumTopUp} will receive a bonus worth of {c_totalReceiverCredit} credits."
msgstr ""

#: src/modules/compute/SubInterfaceModal.tsx
msgid "Example"
msgstr ""

#: src/modules/currency/CurrencyModal.tsx
#: src/modules/currency/DisplayCurrencyRate.tsx
msgid "Exchange rate"
msgstr ""

#. Short of: Excluding (VAT/GST etc.)
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Excl. {vatSymbol}"
msgstr ""

#. The number of fail-over nodes:
#: src/modules/services/ServiceCreate.tsx
msgid "Fail-over nodes"
msgstr ""

#: src/modules/api/ApiError.ts
msgid "Failed to connect to server"
msgstr ""

#: src/modules/billing/account_validation/digio/utils.ts
msgid "Failed to load Digio library"
msgstr ""

#: src/modules/billing/paypal/utils.ts
msgid "Failed to load PayPal library"
msgstr ""

#: src/modules/billing/popup/popup.ts
msgid "Failed to open popup, possible popup blocker usage"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "File"
msgstr ""

#: src/modules/storage/bucket/BucketView.tsx
msgid "Files"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Files will be uploaded to"
msgstr ""

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "Firewall"
msgstr ""

#: src/modules/network/NetworkCreate.tsx
msgid "Firewall is available at no additional cost."
msgstr ""

#: src/modules/compute/VmView.tsx
msgid "Firewall name"
msgstr ""

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Firewall now available"
msgstr ""

#: src/modules/user/ProfileView.tsx
msgid "First name"
msgstr ""

#: src/modules/services/ConnectionDetails.tsx
msgid "Flags"
msgstr ""

#: src/modules/api/resourceTypes.tsx
msgid "Floating IP"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Folder"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Folder name"
msgstr ""

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "For every new user who signs up through the referral program and tops up at least {c_minimumTopUp}, you will receive {c_promoterCredit} worth of free credits."
msgstr ""

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "For every new user who signs up using your referral code and adds a verified payment method, you will receive {c_promoterCredit} worth of free credits."
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "For pay-as-you-go billing account you can select the payment method after the account is created and validated."
msgstr ""

#: src/modules/compute/labels.tsx
msgid "For the snapshots you will only pay for the storage used by the snapshot."
msgstr ""

#. Unsafely shut down the virtual machine
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
msgid "Force stop"
msgstr ""

#: src/modules/login/Login.tsx
#: src/modules/login/Login.tsx
msgid "Forgot password"
msgstr ""

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Forwarding rules"
msgstr ""

#. At no cost. | POS: Noun
#: src/components/forms/MonthlyCostField.tsx
msgid "Free"
msgstr ""

#: src/modules/compute/VmView.tsx
#: src/modules/services/Backups.tsx
msgid "Frequency"
msgstr ""

#: src/modules/services/ServicesList.tsx
msgid "from"
msgstr ""

#: src/modules/compute/VmCreate.tsx
msgid "From"
msgstr ""

#. Billing account restriction level
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Frozen"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Full path"
msgstr ""

#: src/modules/services/ServiceView.tsx
msgid "Fully managed database so you can focus on your code."
msgstr ""

#: src/modules/api/resourceTypes.tsx
msgid "Fully managed services - we handle the provisioning of underlying infrastructure and the management of the service."
msgstr ""

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Future"
msgstr ""

#. Payment gateway that the card is connected to
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Gateway"
msgstr ""

#. unit: gigabytes
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/l10n/units.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "GB"
msgstr ""

#. Example: 50 GB (of) disk
#: src/modules/l10n/units.tsx
msgid "GB disk"
msgstr ""

#. Example: 16 GB (of) RAM
#: src/modules/compute/VmSizeSelect.tsx
#: src/modules/l10n/units.tsx
msgid "GB RAM"
msgstr ""

#. unit: gigabyte-hours (storage usage)
#: src/modules/l10n/units.tsx
msgid "GBh"
msgstr ""

#. Explanation: Generate the subnet range automatically
#: src/modules/network/NetworkCreate.tsx
msgid "Generate (recommended)"
msgstr ""

#: src/modules/access/AccessCreate.tsx
msgid "Generate an API access token to use our <0>API</0>."
msgstr ""

#: src/modules/access/scopeLabel.tsx
msgid "Global"
msgstr ""

#: src/modules/error/ErrorFallback.tsx
msgid "Go to dashboard"
msgstr ""

#. Sales tax acronym in India
#: src/styles/hostzop/theme.tsx
msgid "GST"
msgstr ""

#. Sales tax acronym in India
#: src/styles/hostzop/theme.tsx
msgid "GST number"
msgstr ""

#. unit: hours
#: src/modules/l10n/units.tsx
msgid "h"
msgstr ""

#. Chat widget greeting
#: src/modules/support/WChatProvider.tsx
msgid "Hello"
msgstr ""

#: src/routes/_main_custom/about.lazy.tsx
msgid "Hello world!"
msgstr ""

#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Hibernate"
msgstr ""

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Hibernated"
msgstr ""

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Hibernating"
msgstr ""

#. Button action
#: src/components/SecretKey.tsx
#: src/modules/services/TextSecret.tsx
msgid "Hide"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Hide details"
msgstr ""

#: src/modules/api/resourceTypes.tsx
msgid "High availability load balancer distributes traffic between virtual machines within the same data center location."
msgstr ""

#. Time period unit
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/metal/offer/period.tsx
msgid "hour"
msgstr ""

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Hourly"
msgstr ""

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Hourly billing cycle only"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Hourly updated usage for current billing period."
msgstr ""

#: src/modules/dashboard/UserAccess.tsx
msgid "I can access"
msgstr ""

#: src/modules/login/ConsentForm.tsx
msgid "I have read and agree to the <0>Terms of Service</0>"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "I'm aware that deletion is permanent"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "If low balance notifications are active and the balance falls below the threshold, you will be notified."
msgstr ""

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "If the active reservation runs out and is not renewed then standard hourly based pricing will be applied."
msgstr ""

#: src/modules/billing/choose_method/InvoiceForm.tsx
msgid "If the invoice payment method is not activated instantly, we will contact you with more details. If you do not receive an email from us soon or the invoice payment does not become active, you can contact us at <0/>."
msgstr ""

#: src/modules/dashboard/Dashboard.tsx
msgid "If you have any questions, found a bug or have a feature request feel free to contact us through <0>support</0>."
msgstr ""

#. Description for billing period field
#: src/modules/metal/offer/period.tsx
msgid "In all calculations a precise number of hours is used: 730 for a month, 2190 for a quarter and 8760 for a year."
msgstr ""

#: src/modules/metal/status/StatusLabels.tsx
msgid "In use"
msgstr ""

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Inactive"
msgstr ""

#. Short of: inbound firewall rules
#: src/modules/network/NetworkList.tsx
msgid "inbound"
msgstr ""

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Inbound rules"
msgstr ""

#. The price has already been included in the virtual machine's price
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Included in VM price"
msgstr ""

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Incoming traffic is allowed only to the specified ports if it originates from the specified sources. All other traffic will be blocked."
msgstr ""

#: src/modules/compute/VmCreate.tsx
msgid "Informative name. It will also be used to generate a suitable hostname for the VM (if applicable)."
msgstr ""

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/ServiceView.tsx
msgid "Infrastructure"
msgstr ""

#: src/modules/compute/VmCreate.tsx
msgid "Initialization script"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Insert code"
msgstr ""

#: src/modules/access/AccessCreate.tsx
msgid "Insert email of the {siteName} user you want to delegate access to. The user will need to accept the access invitation from their profile view."
msgstr ""

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Insufficient funds"
msgstr ""

#. Field label: identifier used to connect a billing account to an external integration
#. Unique ID number to integrate with external services
#: src/modules/billing/billingAccount/fieldsInfo.tsx
#: src/styles/defaultTheme.tsx
msgid "Integration ID"
msgstr ""

#. Card expiration validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Invalid month"
msgstr ""

#: src/modules/api/ApiError.ts
msgid "Invalid response from server. Blocked by Stormwall."
msgstr ""

#: src/modules/api/ApiError.ts
msgid "Invalid response type from server: Received {ct} instead of JSON."
msgstr ""

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Invalid signup. The account may already exist."
msgstr ""

#. Card expiration validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Invalid year"
msgstr ""

#. What caused the billing account status change
#: src/modules/billing/invoice/DownloadPdf.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Invoice"
msgstr ""

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Invoice {id}"
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Invoice details"
msgstr ""

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Invoice email"
msgstr ""

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Invoice has been paid"
msgstr ""

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Invoice is not payable"
msgstr ""

#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Invoice name"
msgstr ""

#. What caused the billing account status change
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Invoice payment"
msgstr ""

#: src/components/themeTrans.tsx
msgid "Invoices"
msgstr ""

#: src/modules/services/IpWhitelist.tsx
msgid "IP"
msgstr ""

#: src/modules/services/AddIpForm.tsx
msgid "IP address"
msgstr ""

#: src/modules/network/firewall/firewallLabels.tsx
msgid "IP address or CIDR range"
msgstr ""

#. A list of IPs permitted to access the service | Legacy wording: IP whitelist
#: src/modules/services/IpWhitelist.tsx
#: src/modules/services/ServiceView.tsx
msgid "IP allowlist"
msgstr ""

#: src/modules/network/firewall/ruleSpec.tsx
msgid "IP prefixes"
msgstr ""

#: src/modules/network/NetworkCreate.tsx
msgid "IP range"
msgstr ""

#: src/modules/network/vpc/VpcView.tsx
msgid "IPv4 range"
msgstr ""

#: src/modules/network/vpc/VpcView.tsx
msgid "IPv6 range"
msgstr ""

#: src/modules/compute/BootFromIsoModal.tsx
msgid "ISO boot"
msgstr ""

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Issue date"
msgstr ""

#. Date the invoice was issued
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Issued"
msgstr ""

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "Keep floating IP"
msgstr ""

#: src/modules/user/ActAsModal.tsx
msgid "Keep in mind that all the actions will be tracked and can be traced back to you."
msgstr ""

#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Key name"
msgstr ""

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Kubernetes Patch Version"
msgstr ""

#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Kubernetes Patch Version Auto update"
msgstr ""

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Kubernetes service can not be created."
msgstr ""

#: src/modules/l10n/LocaleButton.tsx
msgid "Language"
msgstr ""

#: src/modules/network/vpc/VpcView.tsx
msgid "Last modified"
msgstr ""

#: src/modules/user/ProfileView.tsx
msgid "Last name"
msgstr ""

#: src/modules/compute/VmView.tsx
msgid "Latest backup"
msgstr ""

#. Timestamp of latest snapshot
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/services/Backups.tsx
msgid "Latest snapshot"
msgstr ""

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Less details"
msgstr ""

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Light"
msgstr ""

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Limit will be removed once the total top up amount reaches <0/>."
msgstr ""

#. Billing account restriction level
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Limited"
msgstr ""

#. Column title for invoice records' totals - record amount subtracted by discount
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Line total"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Linked resources"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "list price"
msgstr ""

#: src/modules/api/resourceTypes.tsx
msgid "Load balancer"
msgstr ""

#. Button action: load the next rows of the list
#: src/modules/billing/statusHistory/StatusHistory.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Load more"
msgstr ""

#: src/modules/billing/progressLabels.tsx
msgid "Loading payment provider"
msgstr ""

#: src/components/forms/WSelect.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Loading..."
msgstr ""

#: src/modules/compute/VmList.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/location/LocationDetail.tsx
#: src/modules/location/LocationField.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/pricing/PricingModal.tsx
#: src/modules/services/ServicesList.tsx
msgid "Location"
msgstr ""

#: src/modules/login/ApiKeyLogin.tsx
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
#: src/modules/login/Login.tsx
#: src/modules/login/LoginLayout.tsx
msgid "Log in"
msgstr ""

#: src/modules/login/Login.tsx
msgid "Log in with Google"
msgstr ""

#: src/modules/main/LogoutConfirmDialog.tsx
#: src/modules/user/LogoutButton.tsx
#: src/modules/user/UserMenu.tsx
msgid "Log out"
msgstr ""

#: src/modules/login/auth0/Auth0Login.tsx
msgid "Logging in"
msgstr ""

#: src/modules/login/auth0/Auth0Login.tsx
msgid "Login error"
msgstr ""

#: src/modules/dashboard/WelcomeModal.tsx
msgid "Look around first"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Low balance notification is not in effect because automated top up is activated."
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Low balance notifications"
msgstr ""

#. MAC address
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "MAC"
msgstr ""

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Machine details"
msgstr ""

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is available for immediate leasing by clients."
msgstr ""

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is being used by client and is being charged."
msgstr ""

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is ordered by client, but does not satisfy the required configuration.<0/>After it has been configured as needed, move to “in use” status."
msgstr ""

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is unavailable or requires repairs."
msgstr ""

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine requires disk cleaning operations."
msgstr ""

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Machine type"
msgstr ""

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/ServiceView.tsx
msgid "Maintenance"
msgstr ""

#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/UserMenu.tsx
msgid "Manage"
msgstr ""

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Manage API keys"
msgstr ""

#: src/modules/api/resourceTypes.tsx
msgid "Managed service"
msgstr ""

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Managed services"
msgstr ""

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Max. surge"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Maximize"
msgstr ""

#: src/modules/billing/forms/FileWithSourceInput.tsx
msgid "Maximum upload file size is {maxFileSizeInMB} MB"
msgstr ""

#. unit: megabytes
#: src/modules/l10n/units.tsx
msgid "MB"
msgstr ""

#. unit: megabytes per second
#: src/modules/l10n/units.tsx
msgid "MB/s"
msgstr ""

#. unit: megabits per second
#: src/modules/l10n/units.tsx
msgid "Mbit/s"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Method"
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Methods available after validation"
msgstr ""

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/services/Metrics.tsx
#: src/modules/services/ServiceView.tsx
msgid "Metrics"
msgstr ""

#: src/modules/compute/monitor/MetricChart.tsx
msgid "Metrics for this resource are not loaded for performance reasons"
msgstr ""

#: src/modules/user/ProfileView.tsx
msgid "MFA is active for your user."
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Minimize"
msgstr ""

#. The selected item was not found
#: src/components/forms/WSelect.tsx
msgid "Missing"
msgstr ""

#. If the disk is a boot disk
#: src/modules/compute/VmView.tsx
msgid "Mode"
msgstr ""

#. Time period unit
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/metal/offer/MetalOfferSection.tsx
#: src/modules/metal/offer/period.tsx
msgid "month"
msgstr ""

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Monthly"
msgstr ""

#: src/components/sidebar/PriceBlock.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/StorageList.tsx
msgid "Monthly cost"
msgstr ""

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "More details"
msgstr ""

#: src/modules/user/ProfileView.tsx
msgid "Multi-factor authentication (MFA)"
msgstr ""

#: src/modules/billing/forms/BillingSelect.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "N/A"
msgstr ""

#: src/components/table/DetailsTableName.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/UpdateSshKeyModal.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageList.tsx
#: src/modules/user/ProfileView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Name"
msgstr ""

#: src/modules/billing/payment_forms/components.tsx
msgid "Name (Min {minChars} chars)"
msgstr ""

#: src/modules/billing/payment_forms/components.tsx
msgid "Name is too short"
msgstr ""

#: src/modules/support/WChatProvider.tsx
msgid "Need help?"
msgstr ""

#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/network/NetworkList.tsx
msgid "Network"
msgstr ""

#: src/modules/compute/MetricsGrid.tsx
msgid "Network bandwidth"
msgstr ""

#: src/modules/compute/VmView.tsx
msgid "Network interfaces"
msgstr ""

#: src/modules/compute/VmView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Networking"
msgstr ""

#. Table column: value after the change
#: src/components/sidebar/SidebarList.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/NetworkList.tsx
msgid "New"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New file name"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New folder"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New folder name"
msgstr ""

#: src/modules/network/VpcNetworkSelect.tsx
msgid "New network"
msgstr ""

#: src/modules/compute/PasswordFields.tsx
msgid "New password"
msgstr ""

#: src/modules/compute/AddSshKeyModal.tsx
msgid "New SSH key"
msgstr ""

#: src/styles/nforce/theme.tsx
msgid "NForce customer ID"
msgstr ""

#: src/modules/billing/BillingAccountInfo.tsx
msgid "No active card"
msgstr ""

#. Chart empty state: no metric samples are available
#: src/modules/compute/monitor/MetricChart.tsx
msgid "No data"
msgstr ""

#. Fail-over is disabled, no fail-over nodes
#: src/modules/services/FailoverNodeSelect.tsx
msgid "No Fail-over"
msgstr ""

#. Shown when the billing account status history is empty
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "No history available."
msgstr ""

#: src/modules/dashboard/UserAccess.tsx
msgid "No one can access your user account yet"
msgstr ""

#: src/modules/dashboard/UserAccess.tsx
msgid "No one has shared access with you yet"
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "No payment will be made currently. You can change your payment method at any time."
msgstr ""

#: src/components/empty.tsx
msgid "No records"
msgstr ""

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "No reservation billing cycles are available for this server."
msgstr ""

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "No restrictions"
msgstr ""

#: src/components/sidebar/EmptyItem.tsx
#: src/modules/dashboard/AppCatalog.tsx
#: src/modules/dashboard/ManagedServices.tsx
msgid "No results found"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "No verified primary payment method"
msgstr ""

#. Short of: Number of storage buckets
#: src/modules/storage/account/StorageAccountView.tsx
msgid "No. of buckets"
msgstr ""

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "No. of files"
msgstr ""

#. Short of: Number of resources
#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/NetworkList.tsx
msgid "No. of resources"
msgstr ""

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "No. of rules"
msgstr ""

#: src/modules/services/Backups.tsx
#: src/modules/services/Metrics.tsx
msgid "Node"
msgstr ""

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Node pool"
msgstr ""

#: src/modules/services/ServiceCreate.tsx
msgid "Node pools"
msgstr ""

#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "nodes"
msgstr ""

#. Items: means files or folders
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Note: If you are deleting substantial number of items, the deletion process may result in an inconsistent state, where some items are deleted while others remain. In the event of such occurrences, please repeat the same action again."
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Note: If your folder contains a substantial number of files, the renaming process will take time and may result in an inconsistent state where some files are moved to a new location, while others remain in the old folder. In the event of such occurrences, please repeat the action by renaming the same folder once more."
msgstr ""

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Note! The owner will know if you have accepted this invitation. They will not be able to access your user account and see or edit any of your resources."
msgstr ""

#: src/modules/notifications/NotificationMenu.tsx
msgid "Notifications"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Notify when balance goes below"
msgstr ""

#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Notify when balance goes below the following threshold. Keep in mind that the actual limit is defined in base currency."
msgstr ""

#. Availability announcement for AMD EPYC cloud resources
#: src/styles/readyidc/theme.tsx
msgid "Now available"
msgstr ""

#: src/modules/metal/status/StatusLabels.tsx
msgid "Offline"
msgstr ""

#. Table column: value before the change
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Old"
msgstr ""

#. Backup frequency
#: src/modules/services/Backups.tsx
msgid "Once a day"
msgstr ""

#: src/modules/compute/VmView.tsx
msgid "Once a week (Wednesday at 02:00 UTC)"
msgstr ""

#: src/modules/storage/account/SuspendedNotice.tsx
msgid "One of your billing accounts has a problem and your buckets have been suspended. See <0>billing account details</0> for more information or contact support to resolve the issue."
msgstr ""

#: src/modules/billing/BillingList.tsx
#: src/modules/billing/ReportStatus.tsx
msgid "Ongoing"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Ongoing balance"
msgstr ""

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
msgid "Online"
msgstr ""

#. Only payment methods that can be charged automatically
#: src/modules/billing/choose_method/ChooseMethod.tsx
msgid "Only automated methods"
msgstr ""

#: src/modules/compute/VmCreate.tsx
msgid "Only the boot disk will be created! This may cause the OS to not boot properly if the configuration in the OS of source snapshot requires additional disks to be present."
msgstr ""

#: src/modules/compute/labels.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Operating system"
msgstr ""

#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Operating system Auto update"
msgstr ""

#: src/modules/login/Login.tsx
msgid "Or"
msgstr ""

#: src/styles/dataxion/theme.tsx
msgid "Order"
msgstr ""

#: src/styles/dataxion/theme.tsx
msgid "Orders"
msgstr ""

#. Short of: Operating system
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "OS"
msgstr ""

#. Short of: outbound firewall rules
#: src/modules/network/NetworkList.tsx
msgid "outbound"
msgstr ""

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Outbound rules"
msgstr ""

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Outgoing traffic is allowed only to the specified ports of the specified destinations. All other traffic will be blocked."
msgstr ""

#: src/modules/billing/BillingList.tsx
msgid "Outstanding amount"
msgstr ""

#: src/modules/billing/ReportStatus.tsx
msgid "Paid"
msgstr ""

#: src/modules/services/ConnectionDetails.tsx
msgid "Parameters"
msgstr ""

#: src/modules/compute/PasswordFields.tsx
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/user/ProfileView.tsx
msgid "Password"
msgstr ""

#: src/modules/compute/PasswordFields.tsx
msgid "Password for the user. Must contain at least one lowercase and one uppercase ASCII letter (a-z, A-Z) and at least one digit (0-9). Minimum length is 8 characters."
msgstr ""

#: src/modules/compute/PasswordFields.tsx
msgid "Passwords do not match"
msgstr ""

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Past"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Path style URL"
msgstr ""

#. Button action: pay for unpaid invoice
#: src/modules/billing/ActionButtons.tsx
msgid "Pay"
msgstr ""

#: src/modules/billing/payment/PaymentModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Pay invoice"
msgstr ""

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Pay now"
msgstr ""

#: src/modules/billing/evc_hormuud/EvcHormuudPaymentForm.tsx
msgid "Pay the total charge amount of <0>{chargeAmount}</0> with EVC Mobile Money to get {creditAmount} credits. Enter your billing account ID <1>{billingAccountId}</1> as the payment reference."
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Pay-as-you-go (recommended)"
msgstr ""

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/paymentMethodLogic.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Paying by invoice"
msgstr ""

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Paying by invoice (declined / suspended)"
msgstr ""

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Paying by invoice (pending)"
msgstr ""

#: src/modules/billing/PaymentReturn.tsx
msgid "Payment authorization check finished."
msgstr ""

#: src/modules/billing/sslcommerz/parseSslcommerzPersistentData.ts
msgid "Payment cancelled"
msgstr ""

#: src/modules/billing/sslcommerz/parseSslcommerzPersistentData.ts
msgid "Payment cancelled due to high risk"
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Payment details"
msgstr ""

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Payment error"
msgstr ""

#: src/modules/billing/payment/paymentUtils.ts
msgid "Payment error: {failure_message}{codeSuffix}"
msgstr ""

#: src/modules/billing/clictopay/parseClictopayPaymentResult.ts
#: src/modules/billing/coingate/parseCoingatePaymentResult.ts
#: src/modules/billing/paypal/parsePaypalCheckoutPaymentResult.tsx
#: src/modules/billing/razorpay/parseRazorpayPersistentData.ts
msgid "Payment failed"
msgstr ""

#. What caused the billing account status change
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/payment/PaymentModal.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Payment method"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Payment methods"
msgstr ""

#: src/modules/billing/payment_forms/components.tsx
msgid "Payment processing with this method takes some time. Purchased credit will be automatically added to your account once the process is complete."
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Payment type"
msgstr ""

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Payment was cancelled"
msgstr ""

#. unit: pieces
#: src/modules/l10n/units.tsx
msgid "pc"
msgstr ""

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/metal/status/StatusLabels.tsx
#: src/modules/user/ProfileView.tsx
msgid "Pending"
msgstr ""

#. Billing account status
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Pending validation"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Period"
msgstr ""

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Permissions"
msgstr ""

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Personal ID number"
msgstr ""

#: src/modules/billing/omise/OmisePaymentForm.tsx
#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "Phone number"
msgstr ""

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Platform provided"
msgstr ""

#: src/modules/billing/choose_method/invoiceMethodLogic.tsx
msgid "Please acknowledge that billing account will not be activated before an administrator has accepted your request."
msgstr ""

#: src/modules/billing/choose_method/useAddMethod.tsx
msgid "Please allow popup windows to use this payment method"
msgstr ""

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Please be patient"
msgstr ""

#: src/modules/billing/progressLabels.tsx
msgid "Please complete the payment in the popup window"
msgstr ""

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Please contact support to remove the limit."
msgstr ""

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Please contact the administrators for further details."
msgstr ""

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Please continue."
msgstr ""

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "Please enter a valid name"
msgstr ""

#: src/modules/login/Login.tsx
msgid "Please enter your email address. We will send you an email to reset your password."
msgstr ""

#: src/modules/access/AccessCreate.tsx
msgid "Please finish adding the email"
msgstr ""

#: src/modules/storage/bucket/bucketMessages.tsx
msgid "Please note that the billing account linked to your storage bucket differs from the one associated with your storage account. We highly recommend aligning them for billing consistency and clearer management."
msgstr ""

#: src/components/forms/MonthlyCostField.tsx
msgid "Please see how the cost of your resource is calculated."
msgstr ""

#: src/modules/network/loadbalancer/TargetServersList.tsx
msgid "Please select a VPC network to choose target servers from."
msgstr ""

#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
msgid "Please select an item in the list"
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Please upload a copy of the business registration document or ID card for verification (max {maxFileSizeInMB}MB)."
msgstr ""

#: src/modules/services/ServiceView.tsx
msgid "Pods and services hosted on this cluster will be stopped and any ephemeral storage will be discarded."
msgstr ""

#: src/modules/billing/popup/popup.ts
msgid "Popup did not return from redirect"
msgstr ""

#: src/modules/billing/popup/popup.ts
msgid "Popup was closed before it could load"
msgstr ""

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Port"
msgstr ""

#: src/modules/network/validatePort.ts
msgid "Port must be between 1 and 65535"
msgstr ""

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Port range"
msgstr ""

#: src/modules/services/ServiceCreate.tsx
msgid "PostgreSQL multi-node setup is a Primary/Standby setup with automatic fail-over."
msgstr ""

#. Resources attached to the billing account that have already been paid for
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Pre-paid resources"
msgstr ""

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Pre-payment"
msgstr ""

#: src/modules/compute/VmList.tsx
msgid "Price"
msgstr ""

#: src/modules/compute/VmCreate.tsx
#: src/modules/pricing/PricingModal.tsx
msgid "Price list"
msgstr ""

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Price per cycle"
msgstr ""

#: src/modules/pricing/PricingModal.tsx
msgid "Price per hour"
msgstr ""

#: src/modules/pricing/PricingModal.tsx
msgid "Price per month"
msgstr ""

#: src/modules/pricing/PricingModal.tsx
msgid "Prices may vary for the options below"
msgstr ""

#. The card that is selected for automatic charging (ie. main)
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
msgid "Primary"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Private"
msgstr ""

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Private images"
msgstr ""

#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
msgid "Private IP"
msgstr ""

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Networking.tsx
#: src/modules/services/ServiceView.tsx
msgid "Private IPv4"
msgstr ""

#: src/modules/services/Networking.tsx
msgid "Private network"
msgstr ""

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Problem with PayPal API."
msgstr ""

#: src/modules/user/ProfileView.tsx
#: src/modules/user/UserMenu.tsx
msgid "Profile"
msgstr ""

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Protocol"
msgstr ""

#: src/modules/compute/VmCreate.tsx
msgid "Provide a valid cloud-config as JSON or YAML. This configuration will be passed as cloud-init user-data to the virtual machine. See cloud-init documentation about cloud-config for all the available options."
msgstr ""

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Provider start of maintenance time window in which Provider may schedule automated cluster updates."
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Public"
msgstr ""

#: src/components/table/DetailsTableIpAddress.tsx
msgid "Public IP addresses are managed in the Network view."
msgstr ""

#: src/components/table/DetailsTableIpAddress.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Public IPv4"
msgstr ""

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Public IPv6"
msgstr ""

#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/user/ProfileView.tsx
msgid "Public key"
msgstr ""

#: src/modules/compute/labels.tsx
msgid "Public key part of the SSH key pair for logging in to the VM. Must be in format <0>ssh-key-type base64encoded...key optional_comment</0>."
msgstr ""

#: src/modules/services/ConnectionDetails.tsx
msgid "Public network"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Public URL"
msgstr ""

#. Short of: Quantity
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Qty."
msgstr ""

#. Time period unit
#: src/modules/metal/offer/period.tsx
msgid "quarter"
msgstr ""

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Quarterly"
msgstr ""

#: src/modules/billing/LimitedBillingAccountNotice.tsx
#: src/modules/compute/MetricsGrid.tsx
msgid "RAM"
msgstr ""

#: src/modules/compute/VmToolbar.tsx
msgid "RDP link"
msgstr ""

#: src/modules/services/ServiceView.tsx
msgid "Read more"
msgstr ""

#. Only read permissions
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Read-only"
msgstr ""

#: src/modules/services/ServiceView.tsx
msgid "Readiness"
msgstr ""

#: src/modules/metal/os/MetalOsSelect.tsx
msgid "Ready"
msgstr ""

#. Table column: why the restriction level changed
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Reason"
msgstr ""

#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
msgid "Reboot"
msgstr ""

#: src/modules/dashboard/RecentlyModified.tsx
msgid "Recent"
msgstr ""

#: src/modules/billing/progressLabels.tsx
msgid "Redirecting to payment gateway"
msgstr ""

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral code"
msgstr ""

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral link"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral program"
msgstr ""

#: src/modules/billing/evc_hormuud/EvcHormuudPaymentForm.tsx
msgid "Refresh credit"
msgstr ""

#: src/modules/billing/account_validation/RefreshStatusButton.tsx
msgid "Refresh status"
msgstr ""

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Registration number"
msgstr ""

#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/ReinstallModal.tsx
msgid "Reinstall"
msgstr ""

#: src/modules/compute/ReinstallModal.tsx
msgid "Reinstalling \"{name}\" will destroy all data on the boot disk and set it to the initial clean OS state. All snapshots and backups are preserved."
msgstr ""

#: src/components/sidebar/ListErrorBoundary.tsx
msgid "Reload"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Reload data"
msgstr ""

#: src/root.tsx
msgid "Reload page"
msgstr ""

#: src/modules/billing/PaymentTopItem.tsx
msgid "Remaining credit <0/>"
msgstr ""

#: src/modules/network/firewall/FirewallView.tsx
msgid "Remove resource"
msgstr ""

#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "Removing the public IPv4 address assignment from this resource will make the resource inaccessible from the public Internet. The IP address will remain reserved to your account. You can manage public IPv4 addresses from the Network menu on the left sidebar."
msgstr ""

#. placeholder {0}: item.grantee_username
#: src/modules/access/delegation/DelegationView.tsx
msgid "Removing user will revoke the rights from \"{0}\" to act as you."
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Rename"
msgstr ""

#: src/modules/billing/invoice/DownloadPdf.tsx
msgid "Report"
msgstr ""

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Report {id}"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Reports"
msgstr ""

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Requested"
msgstr ""

#: src/modules/metal/commitment/AddCommitmentModal.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Reservations"
msgstr ""

#. Disk status
#: src/modules/disks/DiskList.tsx
#: src/modules/disks/DiskStatusBadge.tsx
msgid "Reserved"
msgstr ""

#: src/modules/metal/commitment/CommitmentPriceBlock.tsx
msgid "Reserved and prepaid until <0/> ({daysRemaining} days remaining). Price shown as a monthly equivalent."
msgstr ""

#: src/modules/user/ProfileView.tsx
msgid "Reset password"
msgstr ""

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmView.tsx
msgid "Resize"
msgstr ""

#: src/modules/compute/DiskAddOrResizeModal.tsx
msgid "Resize disk"
msgstr ""

#: src/modules/compute/VmResizeModal.tsx
msgid "Resizing is only possible when the virtual machine is stopped."
msgstr ""

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Resource allocation is forbidden. Existing resources are deleted."
msgstr ""

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Resource allocation is forbidden. Existing resources are stopped."
msgstr ""

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Resource allocation is limited"
msgstr ""

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Resource name"
msgstr ""

#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Resources"
msgstr ""

#. VM is accessible by:
#: src/modules/compute/VmView.tsx
msgid "resources in the same VPC network using private addresses of primary interfaces"
msgstr ""

#. VM is accessible by:
#: src/modules/compute/VmView.tsx
msgid "resources in the VPCs shared by VLAN sub-interfaces using their respective private address"
msgstr ""

#: src/modules/billing/omise/parseOmisePersistentData.ts
msgid "Response seems to be taking longer than expected. Wait a bit and refresh the page to see changes reflected. The result might be either successful or unsuccessful."
msgstr ""

#: src/modules/billing/payment/paymentUtils.ts
msgid "Response seems to be taking more time than expected. Wait a bit and refresh the page to see payment status changes reflected. If it doesn't happen in a reasonable time, please contact support."
msgstr ""

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/Backups.tsx
msgid "Restore"
msgstr ""

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/services/Backups.tsx
msgid "Restore from backup"
msgstr ""

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restore from snapshot"
msgstr ""

#: src/modules/services/Backups.tsx
msgid "Restoring from a backup will overwrite the service's state with the selected backup's state."
msgstr ""

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restoring this backup will overwrite the current state."
msgstr ""

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restoring this snapshot will overwrite the current state."
msgstr ""

#: src/modules/access/scopeLabel.tsx
msgid "Restricted"
msgstr ""

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Restriction level changed"
msgstr ""

#: src/modules/compute/VmView.tsx
msgid "Retention"
msgstr ""

#. Button action
#: src/components/sidebar/ErrorItem.tsx
#: src/modules/notifications/toast.tsx
msgid "Retry"
msgstr ""

#: src/styles/readyidc/theme.tsx
msgid "Revolutionize your cloud with AMD EPYC"
msgstr ""

#. Registre National des Entreprises (RNE) company registration document
#: src/styles/dataxion/theme.tsx
msgid "RNE document"
msgstr ""

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Rules from all attached firewalls are combined, a connection is allowed if there is at least one rule that allows it."
msgstr ""

#: src/modules/metal/MetalCreate.tsx
msgid "Run your applications on Bare Metal Servers for full control, security, and raw performance. Provision a dedicated server optimized for your most demanding use cases."
msgstr ""

#. Virtual machine status
#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/monitor/MetricChart.tsx
#: src/modules/compute/statusLabels.tsx
#: src/modules/services/ServicesList.tsx
msgid "Running"
msgstr ""

#: src/modules/storage/StorageCreate.tsx
msgid "S3-compatible object storage allows you to scale your storage resources up and down without any upfront payments. Create a new storage account, create some buckets and start storing your data in a scalable way - Pay-as-you-grow."
msgstr ""

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
#: src/modules/currency/CurrencyModal.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Save"
msgstr ""

#: src/modules/billing/progressLabels.tsx
msgid "Saving payment information"
msgstr ""

#: src/modules/billing/QrCodeDisplay.tsx
msgid "Scan the QR code to pay"
msgstr ""

#: src/modules/access/AccessCreate.tsx
#: src/modules/user/ProfileView.tsx
msgid "Scope"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Search"
msgstr ""

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Secret access key"
msgstr ""

#: src/modules/billing/forms/FileWithSourceInput.tsx
msgid "Select a file"
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Select a payment method"
msgstr ""

#: src/components/forms/WSelect.tsx
msgid "Select an option"
msgstr ""

#. placeholder {0}: siteCurrencyInfo.title
#: src/modules/currency/CurrencyModal.tsx
msgid "Select your display currency to view prices in your preferred currency. Displayed amounts and exchange rates are indicative and for informational purposes only. All transactions are processed in the underlying currency ({0}), and final charges may vary based on your payment provider's rates."
msgstr ""

#: src/modules/currency/CurrencyModal.tsx
msgid "Select your preferred currency"
msgstr ""

#: src/modules/compute/WVnc.tsx
msgid "Send Ctrl+Alt+Del"
msgstr ""

#: src/modules/login/Login.tsx
msgid "Send email"
msgstr ""

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Server"
msgstr ""

#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/pricing/PricingModal.tsx
msgid "Server class"
msgstr ""

#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServiceView.tsx
msgid "Service"
msgstr ""

#: src/modules/services/ServiceCreate.tsx
msgid "Service name"
msgstr ""

#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/services/ServicesList.tsx
msgid "Services"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Set by an administrator"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Set default"
msgstr ""

#. 'private' is a literal string
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Set object's ACL to 'private'"
msgstr ""

#. 'public-read' is a literal string
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Set object's ACL to 'public-read'"
msgstr ""

#. Button action
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/dashboard/UserAccess.tsx
msgid "Share access"
msgstr ""

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on Facebook"
msgstr ""

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on LinkedIn"
msgstr ""

#. X is the social network
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on X"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Share temporarily"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sharing duration"
msgstr ""

#. Button action
#: src/components/SecretKey.tsx
#: src/modules/services/TextSecret.tsx
msgid "Show"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Show details"
msgstr ""

#. An item is any kind of resource being managed (e.g. VM, disk, bucket, etc).
#: src/modules/dashboard/RecentlyModified.tsx
msgid "Showing {limit} latest items"
msgstr ""

#: src/modules/billing/BillingDiscountNotice.tsx
msgid "Showing list prices. Discount applied in the cost summary."
msgstr ""

#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
msgid "Sign up"
msgstr ""

#: src/modules/login/Login.tsx
msgid "Sign up with Google"
msgstr ""

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageList.tsx
msgid "Size"
msgstr ""

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
msgid "Size (GB)"
msgstr ""

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
msgid "Snapshots"
msgstr ""

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Social share"
msgstr ""

#: src/modules/metal/spec/SpecRadio.tsx
msgid "Sold out"
msgstr ""

#. Label for dropdown menu that selects by what files are sorted. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort"
msgstr ""

#: src/components/sidebar/SortMenu.tsx
msgid "Sort by"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by date"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by name"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by size"
msgstr ""

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
msgid "Source port"
msgstr ""

#: src/modules/network/loadbalancer/validatePorts.ts
msgid "Source port must be unique"
msgstr ""

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Sources"
msgstr ""

#: src/modules/compute/AddSshKeyModal.tsx
msgid "SSH key does not match required pattern"
msgstr ""

#: src/modules/compute/VmCreate.tsx
#: src/modules/user/ProfileView.tsx
msgid "SSH keys"
msgstr ""

#: src/modules/compute/VmCreate.tsx
msgid "SSH keys can be managed under your <0>user profile</0>."
msgstr ""

#: src/modules/compute/VmToolbar.tsx
msgid "SSH link"
msgstr ""

#: src/modules/compute/VmRootUserWarning.tsx
msgid "SSH might not be available for root user due to operating system initial setup. Please use virtual console to access the system and make the SSH server config changes according to your needs."
msgstr ""

#. Button action
#: src/modules/compute/BootFromIsoModal.tsx
#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/support/WChatProvider.tsx
#: src/modules/user/ActAsModal.tsx
msgid "Start"
msgstr ""

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Start date"
msgstr ""

#: src/modules/billing/account_validation/digio/StartDigioValidationButton.tsx
msgid "Start here"
msgstr ""

#: src/modules/network/NetworkCreate.tsx
msgid "Start managing your networks by creating a new network resource."
msgstr ""

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Start port"
msgstr ""

#: src/modules/network/firewall/validatePorts.ts
msgid "Start port must be unique"
msgstr ""

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Start something new"
msgstr ""

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Start time"
msgstr ""

#: src/modules/billing/progressLabels.tsx
msgid "Starting payment"
msgstr ""

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "State"
msgstr ""

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Status"
msgstr ""

#. Short of: billing account status history
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Status history"
msgstr ""

#: src/modules/compute/ModalHeaderBlock.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Stop"
msgstr ""

#. Virtual machine status
#: src/modules/compute/ModalHeaderBlock.tsx
#: src/modules/compute/statusLabels.tsx
#: src/modules/services/ServicesList.tsx
msgid "Stopped"
msgstr ""

#. Virtual machine status
#: src/modules/compute/statusLabels.tsx
msgid "Stopping"
msgstr ""

#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/storage/StorageList.tsx
msgid "Storage"
msgstr ""

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Storage access keys"
msgstr ""

#: src/modules/api/resourceTypes.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Storage account"
msgstr ""

#: src/modules/api/resourceTypes.tsx
msgid "Storage bucket"
msgstr ""

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "Storage bucket name"
msgstr ""

#. List of S3 storage buckets
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Storage buckets"
msgstr ""

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Street address"
msgstr ""

#: src/modules/services/ConnectionDetails.tsx
msgid "String"
msgstr ""

#: src/modules/network/NetworkCreate.tsx
msgid "Subnet range (CIDR)"
msgstr ""

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Subtotal"
msgstr ""

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Subtotal before discounts"
msgstr ""

#. Button label. Short of: Contact customer support
#: src/modules/main/TopNav.tsx
msgid "Support"
msgstr ""

#. Billing account status
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Suspended"
msgstr ""

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Suspension reason changed"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Switch to Grid view"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Switch to List view"
msgstr ""

#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "system"
msgstr ""

#. What caused the billing account status change
#. Who changed the billing account status
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "System"
msgstr ""

#: src/modules/compute/labels.tsx
msgid "Take a snapshot to create an instant image of your virtual machine's current state. You can later use the snapshot to restore your virtual machine state or create a new virtual machine from the snapshot with modified size parameters."
msgstr ""

#: src/modules/compute/VmView.tsx
msgid "Take snapshot"
msgstr ""

#: src/modules/dashboard/RecentlyModified.tsx
msgid "Take some action and you'll never see this cactus again."
msgstr ""

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Target port"
msgstr ""

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Target servers"
msgstr ""

#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/WVnc.tsx
msgid "Terminal"
msgstr ""

#. Billing account restriction level
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Terminated"
msgstr ""

#: src/modules/login/ConsentForm.tsx
msgid "Terms of Service"
msgstr ""

#: src/modules/pricing/PricingModal.tsx
msgid "The actual cost of your resource is calculated based on the below prices and your actual hourly usage. All prices are per one unit of resource (1 vCPU or 1 GiB). Prices do not contain taxes."
msgstr ""

#: src/modules/billing/forms/BillingSelect.tsx
msgid "The billing account has been closed and is no longer available."
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "The campaign code is activated only after a successful top up."
msgstr ""

#: src/modules/user/ActAsModal.tsx
msgid "The entire user interface will switch and act as you were that user. Once you are finished you can stop the session by clicking “Back to your account” button on the header bar and the user interface will switch back to your account."
msgstr ""

#: src/modules/billing/ConversionMessage.tsx
msgid "The final exchange rate and charge amount will be determined at the moment of actual payment."
msgstr ""

#: src/modules/billing/promotionNotices.tsx
msgid "The first top up will unlock your complimentary free credit of <0><1/></0>."
msgstr ""

#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "The format is MM/YY"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "The link expires on:"
msgstr ""

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "The name can only contain lowercase alphanumeric characters and dashes, it must start with a lowercase letter or number, the allowed length is 3–63."
msgstr ""

#: src/modules/compute/ChangePasswordModal.tsx
msgid "The password can be changed for any existing user account."
msgstr ""

#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "The phone/mobile number to contact if any issue arises"
msgstr ""

#: src/components/forms/MonthlyCostField.tsx
msgid "The price is approximate, the cost of your resource will be calculated based on your actual hourly usage."
msgstr ""

#: src/modules/compute/PasswordFields.tsx
msgid "The re-typed password, to ensure that it has been entered correctly."
msgstr ""

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "The selected billing account does not have enough credit to purchase this reservation."
msgstr ""

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "The selected billing account is limited and can not create reservations."
msgstr ""

#: src/modules/network/NetworkCreate.tsx
msgid "The subnet must fall within one the following IP blocks:"
msgstr ""

#: src/modules/compute/ChangePasswordModal.tsx
msgid "The user account for which password will be set."
msgstr ""

#: src/modules/login/Login.tsx
msgid "There was an error verifying your email address."
msgstr ""

#: src/components/sidebar/ErrorItem.tsx
msgid "There was an error while creating your resource."
msgstr ""

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "These credentials are only for the initial login. It is recommended to change these immediately."
msgstr ""

#. This resource was not found
#: src/modules/error/ErrorFallback.tsx
msgid "This {resourceTypeName} is gone"
msgstr ""

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "This bare metal server is still being set up."
msgstr ""

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "This billing account has limited capabilities when creating resources."
msgstr ""

#: src/modules/dashboard/BillingAccounts.tsx
msgid "This billing account is limited"
msgstr ""

#: src/modules/compute/VmCreate.tsx
msgid "This distribution adds a <0/> cost per hour for licensing (<1/> per month)."
msgstr ""

#: src/components/forms/requiredMessage.tsx
msgid "This field is required"
msgstr ""

#: src/modules/storage/account/CreateKeyModal.tsx
msgid "This key has access to all buckets under this storage account. To restrict access to specific buckets, create a separate storage account."
msgstr ""

#. This page was not found
#: src/modules/error/ErrorFallback.tsx
msgid "This page is gone"
msgstr ""

#: src/modules/services/Access.tsx
#: src/modules/services/Networking.tsx
msgid "This service is accessible only by resources in the same VPC network using these private addresses."
msgstr ""

#: src/modules/compute/VmView.tsx
msgid "This virtual machine is accessible by:"
msgstr ""

#: src/modules/network/firewall/FirewallDeleteModal.tsx
msgid "This will delete the firewall and its associated rules, and they will no longer apply to any assigned resources."
msgstr ""

#: src/modules/compute/VmToolbar.tsx
msgid "This will forcefully shut down your resource \"{name}\". For stopped resources you will only be charged for the storage."
msgstr ""

#: src/modules/services/ServiceView.tsx
msgid "This will hibernate cluster \"{display_name}\"."
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/storage/StorageCreate.tsx
msgid "This will only be used within the system so it's easy for you to recognize the account if you have several."
msgstr ""

#: src/modules/compute/VmToolbar.tsx
msgid "This will reboot your resource \"{name}\"."
msgstr ""

#: src/modules/services/IpWhitelist.tsx
msgid "This will remove the address or range from the allowlist.<0/>Note that an empty allowlist will permit connections from any address."
msgstr ""

#: src/modules/services/ServiceView.tsx
msgid "This will shut down your resource \"{display_name}\". If graceful shutdown does not finish in 120 seconds, then a forceful stop will be carried out. For stopped resources you will only be charged for the storage."
msgstr ""

#: src/modules/compute/VmToolbar.tsx
msgid "This will shut down your resource \"{name}\". If graceful shutdown does not finish in 120 seconds, then a forceful stop will be carried out. For stopped resources you will only be charged for the storage."
msgstr ""

#: src/modules/network/loadbalancer/LoadBalancerDeleteModal.tsx
msgid "This will stop forwarding traffic to the targets and remove the load balancer."
msgstr ""

#. Amount below which a low balance notification will be sent
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Threshold"
msgstr ""

#. This page was not found
#: src/modules/error/ErrorFallback.tsx
msgid "Time to move on. Here are some ideas where to go next:"
msgstr ""

#: src/modules/error/ErrorFallback.tsx
msgid "Time to move on. This item is deleted or you do not have access."
msgstr ""

#: src/modules/billing/razorpay/RazorpayPaymentForm.tsx
msgid "Timed out waiting for a response from Razorpay"
msgstr ""

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Timezone"
msgstr ""

#: src/modules/billing/BillingAccountNotices.tsx
msgid "To activate a billing account, please add a credit card as a payment method or contact support to enable invoice payments."
msgstr ""

#: src/modules/services/IpWhitelist.tsx
msgid "To restrict connections to the service you have to add at least one inbound IP to the allowlist (All other public and private connections will be denied). You can specify a single IPv4 address or a block of addresses using CIDR notation (e.g. 1.1.1.0/24)"
msgstr ""

#: src/modules/billing/BillingAccountNotices.tsx
#: src/modules/dashboard/WelcomeModal.tsx
msgid "To start using the platform you need to first setup billing account. You are welcome to click around to familiarize yourself with the system and come back to billing account creation at any time you are ready to start building your first resources."
msgstr ""

#: src/modules/login/ConsentForm.tsx
msgid "To use our services, you need to agree to the Terms of Service."
msgstr ""

#: src/modules/access/token/TokenView.tsx
msgid "Token"
msgstr ""

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Top up"
msgstr ""

#. How much to top up | POS: Noun
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Top up amount"
msgstr ""

#: src/modules/billing/promotionNotices.tsx
msgid "Top up at least <0><1/></0> to obtain <2><3/></2> of referral code bonus."
msgstr ""

#: src/modules/billing/ActionButtons.tsx
msgid "Top up now"
msgstr ""

#. Top up your billing account
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Top up your account"
msgstr ""

#. What caused the billing account status change
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Top-up"
msgstr ""

#. Invoices for billing account top-ups
#: src/components/themeTrans.tsx
msgid "Top-up invoices"
msgstr ""

#: src/styles/dataxion/theme.tsx
msgid "Top-up orders"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Top-up threshold reached"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Top-ups of <0/> are below the threshold of <1/>"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Top-ups of <0/> reached the threshold of <1/>"
msgstr ""

#. Total amount of the invoice
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Total"
msgstr ""

#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Total charge"
msgstr ""

#. Short of: Total excluding
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Total excl. {vatSymbol}"
msgstr ""

#: src/components/themeTrans.tsx
msgid "Total of all unpaid invoices. Including {vatSymbol}."
msgstr ""

#: src/styles/dataxion/theme.tsx
msgid "Total of all unpaid orders. Including VAT."
msgstr ""

#: src/modules/billing/CurrencyPaymentFees.tsx
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Transaction fee"
msgstr ""

#. Table column: what caused the change | POS: Noun
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Trigger"
msgstr ""

#: src/modules/access/AccessCreate.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageCreate.tsx
msgid "Type"
msgstr ""

#: src/modules/compute/labels.tsx
msgid "UEFI variables (NVRAM) will not persist across reboots."
msgstr ""

#: src/modules/access/AccessList.tsx
msgid "UI"
msgstr ""

#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/ipAddress/UnAssignButton.tsx
msgid "Unassign"
msgstr ""

#. State of IP address
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/UnassignedItem.tsx
msgid "Unassigned"
msgstr ""

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Unit"
msgstr ""

#. Label for an unknown item in a select control
#: src/components/EnumBadge.tsx
#: src/modules/billing/BillingAccountLink.tsx
#: src/modules/network/NetworkList.tsx
msgid "Unknown"
msgstr ""

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Unknown Auth0 error"
msgstr ""

#: src/modules/access/scopeLabel.tsx
msgid "Unknown billing account"
msgstr ""

#: src/modules/billing/payment/paymentUtils.ts
msgid "Unknown payment error{codeSuffix}"
msgstr ""

#: src/modules/disks/AttachedToSelect.tsx
#: src/modules/network/AssignToSelect.tsx
msgid "Unknown resource"
msgstr ""

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Unlink target"
msgstr ""

#: src/modules/billing/BillingList.tsx
#: src/modules/billing/ReportStatus.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Unpaid"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Unpaid amount"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Unverified"
msgstr ""

#: src/modules/compute/UpdateSshKeyModal.tsx
msgid "Update"
msgstr ""

#: src/modules/compute/UpdateSshKeyModal.tsx
msgid "Update SSH key"
msgstr ""

#. Button action to upload a file. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Upload"
msgstr ""

#: src/styles/dataxion/theme.tsx
msgid "Upload a copy of only the RNE document for verification"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Uploading files"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Uploads are still in progress. If you leave this page, progress will no longer be shown and uploads may be interrupted. Leave anyway?"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Usage"
msgstr ""

#. What caused the billing account status change
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Usage charge"
msgstr ""

#: src/modules/compute/VmCreate.tsx
msgid "Use the ISO boot option after the virtual machine has been created to install an operating system yourself."
msgstr ""

#. Who changed the billing account status
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "User"
msgstr ""

#: src/modules/dashboard/UserAccess.tsx
msgid "User access"
msgstr ""

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/UserAccess.tsx
msgid "User must accept access invitation from their profile view"
msgstr ""

#. Link to regular user interface
#: src/modules/user/UserMenu.tsx
msgid "User view"
msgstr ""

#: src/modules/access/delegation/AddImpersonationForm.tsx
msgid "User's email"
msgstr ""

#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
msgid "Username"
msgstr ""

#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/ProfileView.tsx
msgid "Users I can access"
msgstr ""

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/ProfileView.tsx
msgid "Users who can access my account"
msgstr ""

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "UUID"
msgstr ""

#: src/modules/billing/payment_forms/labels.tsx
msgid "Valid thru"
msgstr ""

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Validation pending"
msgstr ""

#: src/modules/compute/ParamsTextField.tsx
msgid "Value does not match required pattern"
msgstr ""

#: src/components/VatText.tsx
msgid "VAT"
msgstr ""

#: src/components/VatText.tsx
msgid "VAT number"
msgstr ""

#: src/modules/billing/LimitedBillingAccountNotice.tsx
#: src/modules/compute/MachineSizeInfo.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "vCPU"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Verified"
msgstr ""

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Verified payment method is missing"
msgstr ""

#: src/modules/billing/progressLabels.tsx
msgid "Verifying payment method"
msgstr ""

#: src/modules/compute/os/OsVersionSelect.tsx
#: src/modules/metal/os/MetalOsSelect.tsx
#: src/modules/services/os/OsVersionSelect.tsx
msgid "Version"
msgstr ""

#. Button action
#: src/components/ResourceLink.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/notifications/toast.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "View"
msgstr ""

#: src/components/table/WTable.tsx
msgid "View all records"
msgstr ""

#: src/modules/compute/VmView.tsx
msgid "View config commands"
msgstr ""

#: src/modules/billing/BillingAccountNotices.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "View details"
msgstr ""

#: src/components/table/WTable.tsx
msgid "View last {limit} records"
msgstr ""

#: src/modules/user/InvitationNotice.tsx
msgid "View more"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Virtual host style URL"
msgstr ""

#: src/modules/api/resourceTypes.tsx
msgid "Virtual machine"
msgstr ""

#: src/modules/compute/SubInterfaceModal.tsx
msgid "VLAN"
msgstr ""

#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmView.tsx
msgid "VLAN ID"
msgstr ""

#: src/modules/services/Networking.tsx
msgid "VPC IP range"
msgstr ""

#: src/modules/compute/VmView.tsx
msgid "VPC name"
msgstr ""

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/VpcRow.tsx
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/services/Networking.tsx
#: src/modules/services/ServiceCreate.tsx
msgid "VPC network"
msgstr ""

#: src/modules/network/NetworkCreate.tsx
msgid "VPC network is available at no additional cost."
msgstr ""

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Wait for verification or add card"
msgstr ""

#: src/modules/billing/progressLabels.tsx
msgid "Waiting for payment confirmation"
msgstr ""

#: src/modules/billing/popup/popup.ts
msgid "Waiting for popup to return from redirect timed out"
msgstr ""

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Waking up"
msgstr ""

#: src/modules/access/AdminUserWarning.tsx
#: src/modules/compute/VmCreate.tsx
msgid "Warning"
msgstr ""

#: src/modules/compute/DiskAddOrResizeModal.tsx
msgid "Warning: It is recommended to stop the virtual machine before resizing the boot disk."
msgstr ""

#: src/modules/billing/choose_method/invoiceMethodLogic.tsx
msgid "We recommend adding a credit card while your request is being processed to activate services right away."
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "We recommend automated top up as it minimizes the risk of running out of funds and thus affecting your server resources."
msgstr ""

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "We've assembled some links to get you started. Develop, test code, and deploy your applications in no time, from prototyping to large-scale development."
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "We've reached the capacity of our file browser. In order to maintain the stability of our user interface, we've terminated the loading of your bucket contents. Please utilize external tools at your disposal to manage the content within your bucket"
msgstr ""

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Welcome"
msgstr ""

#: src/modules/dashboard/WelcomeModal.tsx
msgid "Welcome!<0/>We're glad you're here."
msgstr ""

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "What would you like to do?"
msgstr ""

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "When balance goes below"
msgstr ""

#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "When reserved but not assigned to a resource IPv4 address will be charged for <0/> / month."
msgstr ""

#: src/modules/network/CreateAndAssignIpField.tsx
msgid "When selected, a public floating IPv4 address will be created and assigned automatically to your resource. If you do not want to have public access to your resource you can unselect the option here or remove the IP address later."
msgstr ""

#: src/modules/compute/VmView.tsx
msgid "When you enable the backup service, an automatic disk-level backup will be created from the boot disk (excluding additional disks). A backup will be created once a week and will be listed here. You can later use the backup images to restore your virtual machine or create a new virtual machine with modified size parameters from the backup."
msgstr ""

#: src/components/loading/Loading.tsx
msgid "While the job is in progress you can:"
msgstr ""

#: src/modules/api/resourceTypes.tsx
msgid "With a firewall you can control incoming and outgoing network traffic based on predetermined security rules."
msgstr ""

#: src/modules/billing/firstAccountNotices.store.tsx
msgid "With first billing account you will be able to unlock your complimentary free credit of <0><1/></0>."
msgstr ""

#. placeholder {0}: currency.title
#: src/modules/billing/ConversionMessage.tsx
msgid "With the selected payment method, you will be charged in {0}."
msgstr ""

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Without an active billing account you can not create any resources, create one to get started."
msgstr ""

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Without an active billing account, resources can not be created."
msgstr ""

#. Time period unit
#: src/modules/metal/offer/period.tsx
msgid "year"
msgstr ""

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Yearly"
msgstr ""

#: src/modules/disks/disk/DiskView.tsx
msgid "Yes"
msgstr ""

#: src/modules/user/ActAsModal.tsx
msgid "You are about to access user \"{name}\""
msgstr ""

#: src/modules/access/AdminUserWarning.tsx
msgid "You are an administrator and are about to delegate your administrative privileges to another user. Please ensure this action is intentional."
msgstr ""

#: src/modules/user/ProfileView.tsx
msgid "You can activate multi-factor authentication for improved security. This works only for the username-password login method. For social login methods (Google etc.), it is usually possible to activate MFA on the third party side."
msgstr ""

#: src/modules/compute/BootFromIsoModal.tsx
msgid "You can boot your virtual machine from a special image for system recovery or to install a fresh operating system. When this mode is activated, a chosen image will be attached as a boot medium. You can then use the Terminal to access your machine. This boot mode is enabled only for the current launch. Next time this virtual machine is started it will follow the normal boot routine."
msgstr ""

#: src/modules/billing/PaymentReturn.tsx
msgid "You can close this page."
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "You can create multiple billing accounts, each linked to specific payment methods. This approach allows you to effectively separate and monitor expenses across different teams, departments, or projects."
msgstr ""

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You can do this from here and continue it later by clicking the link in the email we send you."
msgstr ""

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "You can earn and give free credits by sharing your unique referral code."
msgstr ""

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "You cannot add another reservation because a future reservation already exists."
msgstr ""

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "You commit to the full price for the selected period as soon as you confirm the reservation."
msgstr ""

#. placeholder {0}: ipAddress.address
#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "You have a floating IP <0>{0}</0> assigned to this resource."
msgstr ""

#: src/modules/billing/firstAccountNotices.store.tsx
msgid "You have an active campaign code (<0>{referralCode}</0>) pending to get additional bonus!"
msgstr ""

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You have billing account validation in progress."
msgstr ""

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You have completed billing account validation process. Please wait for the final decision."
msgstr ""

#: src/modules/notifications/NotificationMenu.tsx
msgid "You have no notifications."
msgstr ""

#: src/modules/billing/QrCodeDisplay.tsx
msgid "You may close this dialog after you have made a payment."
msgstr ""

#: src/modules/billing/payment/PaymentModal.tsx
msgid "You may close this dialog window for now."
msgstr ""

#: src/modules/storage/bucket/BucketView.tsx
msgid "You need to have at least one access key for browsing files in this bucket."
msgstr ""

#: src/modules/billing/account_validation/GeneralBaValidationBlock.tsx
msgid "You will be able to set up payment methods and use cloud services once the validation is approved."
msgstr ""

#: src/modules/billing/NoValidBillingAccountNotice.tsx
msgid "You will be able to set up payment methods and use cloud services once the validation is complete."
msgstr ""

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "You will not be charged until it is ready."
msgstr ""

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Your account has been suspended"
msgstr ""

#: src/modules/billing/ConversionMessage.tsx
msgid "Your actual charge will be <0/>, with exchange rate of <1/>."
msgstr ""

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Your billing account has been suspended. See billing account details for more information and <0>contact support</0> to resolve the issue."
msgstr ""

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Your billing account has been topped up"
msgstr ""

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Your billing account must have positive balance to get activated."
msgstr ""

#: src/modules/login/Login.tsx
msgid "Your email address has been successfully verified. You can now log in."
msgstr ""

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Your email address has changed since you started validation. Please start over."
msgstr ""

#: src/modules/billing/BillingDiscountNotice.tsx
msgid "Your selected billing account has {discount}% discount"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Your storage bucket contains a substantial number of files, and we've temporarily halted the loading process. Simply click the \"Load More\" button to continue loading the next batch of files."
msgstr ""

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Zip/postal code"
msgstr ""
